module.exports = __webpack_public_path__ + "static/media/icon_login_on.7e8ae2e2.svg";